import { Tooltip } from "antd";
import * as React from "react";
import { ZEntityError } from "src/business/error/ZEntityError";

import { MfExternalErrorIcon } from "../MfExternalErrorIcon";
import * as styles from "./EntityErrorsView.module.less";

type PropsEntityErrorsView = {
  extErrors: ZEntityError[] | undefined;
};

export const EntityErrorsView: React.FC<PropsEntityErrorsView> = ({
  extErrors,
}) => {
  if (!extErrors || extErrors.length === 0) return null;
  const errList = Array.from(new Set(extErrors.map(({ message }) => message)));
  const warning = extErrors.every((error) => error.warning);

  const title = (
    <ul className={styles.list}>
      {errList.map((message) => (
        <li key={message}>{message}</li>
      ))}
    </ul>
  );
  return (
    <Tooltip
      title={title}
      placement="bottomLeft"
      arrow={{ pointAtCenter: true }}
    >
      <div>
        <MfExternalErrorIcon warning={warning} />
      </div>
    </Tooltip>
  );
};
